export default "__VITE_ASSET__D1o2SETU__"